import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CustomUserState, StateWithCustomUser } from '../user-state';
import { getCustomUserState } from './feature.selector';

export const getJoinLoyaltyProgramState: MemoizedSelector<
  StateWithCustomUser,
  StateUtils.LoaderState<void>
> = createSelector(getCustomUserState, (state: CustomUserState) => state.joinLoyaltyProgram);

export const getLoyaltyProgramLoading: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getJoinLoyaltyProgramState,
  (state) => StateUtils.loaderLoadingSelector(state),
);

export const getLoyaltyProgramError: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getJoinLoyaltyProgramState,
  (state) => StateUtils.loaderErrorSelector(state),
);

export const getLoyaltyProgramSuccess: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getJoinLoyaltyProgramState,
  (state) => StateUtils.loaderSuccessSelector(state),
);
